import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, CardBody, Tooltip} from "reactstrap";

function QuestionContainer(props) {
	const {component, classes, answersColumns, gridLine} = props

	const getColMd = () => {
		if (answersColumns) {
			return "columns-" + parseInt(answersColumns)
		}

		return "columns-1";
	}

	return (
		<CardBody className={"answer-area "}>
			<div className={"mx-0 d-grid position-relative " + getColMd() + " " + classes}>
				{component}
				{gridLine && <div className={"grid-line"} />}
			</div>
		</CardBody>
	);
}

QuestionContainer.propTypes = {
	classes: PropTypes.string,
	component: PropTypes.any,
	gridLine: PropTypes.bool,
	answersColumns: PropTypes.number
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(QuestionContainer);